// 统计
import * as activity from "activityConfigES";

export const init = function () {
	activity.stat();
	activity.listen({ 'form-submit': '兑换点击次数' }, 'click');
	activity.listen({ 'form-submit': '兑换点击人数' }, 'user');
};